import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";

// Placeholder shown on the empty Ask AI sidebar (profile tabs and non-1-on-1
// meetings), above the Ask AI input.
const AskAiSidebarEmptyState = () => {
  return (
    <div className="w-full p-8 flex flex-col items-center text-center gap-4">
      <TopicflowIcon type="ai" className="w-9 h-9 text-violet-500" />
      <div className="flex flex-col items-center gap-1">
        <div className="tf-header-base-light">Ask Topicflow AI</div>
        <div className="tf-body-sm-light">
          Ask anything below, or type "/" to use a skill.
        </div>
      </div>
    </div>
  );
};

export default AskAiSidebarEmptyState;
